// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"219":"52b34c21","586":"28b0df62"}[chunkId] + ".js";
};